export default defineNuxtRouteMiddleware(async (to) => {
  if (to.fullPath.includes('//')) {
    return window.location = to.fullPath.replace(/\/{2,}/g, '/');
  }
});
